import React from "react";
import propTypes from "prop-types";
import {
	HitWrapper,
	HitImageWrapper,
	HitTextWrapper,
	HitMetaDataWrapper,
	HitCategory,
	VideoHitWrapper,
	H2,
} from "./StyledSearch";
import LazyBackgroundImage from "Framework/lazy/LazyBackgroundImage";
import { Video, MockButton } from "Components/Video";

export const SearchHit = (searchHit) => {
	const { Heading, Url, DocumentType, Category, VideoHit, isMixedContent, Image } = searchHit;

	const isVideoHit = DocumentType === "Video";
	return isMixedContent || !isVideoHit ? (
		<HitWrapper href={Url}>
			<HitImageWrapper>
				<LazyBackgroundImage source={Image}>
					{isVideoHit && (
						<MockButton>
							<i className="icon-play"></i>
						</MockButton>
					)}
				</LazyBackgroundImage>
			</HitImageWrapper>
			<HitTextWrapper>
				<HitMetaDataWrapper>
					{Category && <HitCategory>{Category}</HitCategory>}
					<HitCategory>{DocumentType}</HitCategory>
				</HitMetaDataWrapper>
				<H2>
					<span>{Heading}</span>
				</H2>
			</HitTextWrapper>
		</HitWrapper>
	) : (
		<VideoHitWrapper>
			<Video  {...VideoHit} {...{ Image, Heading }} isBlock  />
		</VideoHitWrapper>
	);
};

SearchHit.propTypes = {
	Heading: propTypes.string,
	Url: propTypes.string,
	Category: propTypes.string,
	Date: propTypes.string,
	Description: propTypes.string,
	Image: propTypes.string,
};
